angular.
module("dx.webapp.exams", [
	"dx.webapp.api",
	"dx.webapp.datetimeinput",
	"dx.webapp.event",
	"dx.webapp.exam",
	"dx.webapp.lists",
	"dx.webapp.navigation",
	"dx.webapp.session",
	"digiexam.components",
	"digiexam.services",

	"dx.ui.components.dialog",
	"dx.ui.components.localize",
	"dx.ui.components.scroll",

	"ngRaven",
	"ngSanitize",
	"dx.webapp.angular",
]);
